<template>
  <base-select
    :value="getValueById"
    :options="getStreets"
    label="searchName"
    searchable
    :taggable="false"
    placeholder="Улица"
    :ellipsisOption="ellipsisOption"
    :disabled="disabled"
    :autocompleteAtOne="autocompleteAtOne"
    @input="changeValue"
  />
</template>

<script>
import { mapGetters } from "vuex";
import { BaseSelect } from "@/components/Custom";

export default {
  name: "FilterStreet",
  components: {
    BaseSelect
  },
  props: {
    value: {
      type: [String, Number, Object],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autocompleteAtOne: {
      type: Boolean,
      default: false
    },
    ellipsisOption: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["getStreets", "streetById"]),

    getValueById() {
      const { streetById, value } = this;
      if (!value) return null;
      return streetById(typeof value === "object" ? value.id : value);
    }
  },
  methods: {
    changeValue(value) {
      if (value) {
        this.$emit("input", value);
      } else {
        this.$emit("input", null);
      }
    }
  }
};
</script>
